/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/8
 * Description: 文件描述
 */
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhCN from '@/components/draggleForm/lang/zh-CN.js'
const zh_CN = {

    routeName: {
        scaleKeyword: '量表关键字设置',
        department: '部门管理',
        StartTest: "开始测试",
        admQuery: "就诊查询",
        prescribe: "患者登记",
        register: "用户登记",
        test: "test",
        icon: '图标',
        builtInIcon: '内置图标',
        shuttleBox: '穿梭框',
        demoShuttle: '穿梭框demo',
        permissions: '权限管理',
        pageControl: '页面权限',
        btnControl: '按钮权限',
        table: '表格',
        multiDataTable: '多选数据表格',
        filterTable: '筛选表格',
        dragSort: '拖拽排序',
        upload: '上传',
        fileUpload: '文件上传',
        editor: '编辑器',
        markdown: 'markdown',
        wangeditor: 'wangeditor',
        clickToEdit: '点击即可编辑',
        home: '主页',
        systemSettings: '系统设置',
        userManage: '用户管理',
        roleManage: '角色管理',
        diagnosisManage: "心理诊断",
        navMenu: '导航菜单',
        baseData: '基础数据',
        menuManage: "菜单管理",
        authManage: "权限管理",
        hospitalManage: '医院管理',
        hospitalManage1: '医院管理1',
        patientManage: '患者管理',
        hospitalSetting: '医院设置',
        doctorListManage: '医生管理',
        departmentManage: '部门管理',
        dictManage: '字典管理',
        dictsortManage: '字典分类管理',
        DesignForm: "量表设计",
        questionManage: "问题管理",
        scaleManage: "量表管理",
        measure: '测量管理',
        introduceDetail: "量表介绍详情",
        patientQuery: "患者查询",
        packageManage: "体检套餐",
        examManage: "体检管理",
        examQuery: "体检查询",
        chineseMedicine: "中医体质辨识",
        physiqueQuery: "体质辨识",
        physiqueResultQuery: "结果查询",
        TrainReg: "训练登记",
        TrainQuery: "结果查询",
        Train: "心理训练",
        ordinaryIndex: "首页",
        newHome: '首页',
        physicalPlan: '体检计划'
    },
    rightMenu: {
        close: '关闭',
        closeOther: '关闭其他',
        closeAll: '全部关闭'
    },
    table: {
        Status: "状态",
        action: '操作',
        stopuse: '停用',
        use: '启用'
    },
    role: {
        superAdmin: '超级管理员',
        admin: '管理员',
        ordinary: '普通用户'
    },
    userDropdownMenu: {
        basicInfor: '基本资料',
        changePassword: '修改密码',
        logout: '退出'
    },
    ...zhCN,
    ...zhLocale //  合并element-ui内置翻译
}

export default zh_CN


// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js